import { BPBadRequestResult } from '@app/api2/api';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import * as React from 'react';
import { RefObject } from 'react';
import { Button, Divider, Form, Grid, Message, Segment } from 'semantic-ui-react';
import { SchemaOf } from 'yup';
import { BPFormError, errorFromObj } from './BPFormError';
import { FormErrorList } from '../FormErrorList';
import { BPButton } from '@/components/bp/bpbutton';

export type BPFormProps<T> = FormikProps<T> & { getFieldName: (s: keyof T) => string }
export interface IBPFormProps<T> {
    initialValues: T;
    enableReinitialize?: boolean;
    onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => void | Promise<any>;
    canSubmit?: (values: T, formikHelpers: FormikProps<T>) => boolean;
    vaildationSchema?: SchemaOf<T>;
    children?: ((props: BPFormProps<T>) => React.ReactNode);
    onCancel?: () => void;
    hideButtons?: boolean;
}

export class BPForm<T extends unknown> extends React.PureComponent<IBPFormProps<T>> {
    formik: React.Ref<FormikProps<any>>;
    constructor(props) {
        super(props);
        this.formik = React.createRef()
    }

    public render() {
        const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
            try {
                formikHelpers.setSubmitting(true);
                const result = this.props.onSubmit(values, formikHelpers);
                if (result && 'then' in result) {
                    await result;
                }
            }
            catch (error) {
                if ((error as BPBadRequestResult).modelErrors)
                    (this.formik as RefObject<any>).current.setErrors((error as BPBadRequestResult).modelErrors)
            }
            finally {
                formikHelpers.setSubmitting(false);
            }
        };

        return <Formik innerRef={this.formik}
            validationSchema={this.props.vaildationSchema as any}
            enableReinitialize={this.props.enableReinitialize ?? true}
            onSubmit={onSubmit}
            initialValues={this.props.initialValues}>
            {(formikProps) => (
                <Form error={!formikProps.isValid} onSubmit={formikProps.handleSubmit}>
                    {this.props.children({ ...formikProps, getFieldName: s => s?.toString() })}
                    <BPFormError {...formikProps} />
                    {!this.props.hideButtons && <Divider />}
                    {!this.props.hideButtons && <Grid.Row clearing={'both'} floated={'right'}>
                        <BPButton type="submit" disabled={formikProps.isSubmitting || (this.props.canSubmit != null && !this.props.canSubmit(formikProps.values, formikProps))}>{window.translation.common.save}</BPButton>
                        {this.props.onCancel &&
                            <BPButton type="button" onClick={() => this.props.onCancel()}>{window.translation.common.cancel}</BPButton>
                        }
                    </Grid.Row>}
                </Form>
            )}
        </Formik>;
    }
}


